import Logo from "../assets/logo.png";
import Location from "../assets/images/location.svg";
import Message from "../assets/images/message.svg";
import Phone from "../assets/images/phone.svg";
import Instagram from "../assets/images/instagram.svg";
import Facebook from "../assets/images/facebook.svg";
import LinkedIn from "../assets/images/linkin.svg";
import Pinterest from "../assets/images/pinterest.png";
import Reddit from "../assets/images/reddit.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer-section paddingTop paddingBottom px-3 px-xl-0">
      <div className="container px-0">
      <div className="row mx-0 align-items-center">
        <div className="col-12 col-md-4 footer-logo ps-0">
          <div className="mb-3">
          <Link to="/"><img height="41" width={104} src={Logo} alt="" /></Link>
          </div>
          <ul className="mb-md-0 mb-3 list-unstyled d-flex flex-row align-items-center justify-content-center justify-content-md-between social-media-links">
            <li><Link target="_blank" to=""><img width={24} height={24} src={Instagram} alt="" /></Link></li>
            <li><Link target="_blank" to="https://www.facebook.com/profile.php?id=61553947454096"><img width={24} height={24} src={Facebook} alt="" /></Link></li>
            <li><img width={24} height={24} src={LinkedIn} alt="" /></li>
            <li><Link target="_blank" to="https://pin.it/3FtdL5B"><img width={24} height={24} src={Pinterest} alt="" /></Link></li>
            <li><Link target="_blank" to="https://www.reddit.com/u/GuruzHQ/s/XrvezEGwB0"><img width={24} height={24} src={Reddit} alt="" /></Link></li>
          </ul>
        </div>
        <div className="col-12 col-md-4 d-flex flex-row flex-wrap footer-menu">
         
         <div className="col-12 col-md-12 d-flex flex-row justify-content-center align-items-center px-0">
         <ul className="menu-list m-0 p-0 list-unstyled d-flex flex-row flex-wrap justify-content-center px-0">
            <li className="mb-1">Testimonials</li>
            <li className="mb-1"><Link className="m-0" to="/Privacypolicy">Privacy Policy</Link></li>
            <li className="mb-1 mb-md-0"><Link className="m-0" to="/Termscondition">Term & Conditions</Link></li>
          </ul>
         </div>
         <div className="col-12 copy-right text-center">
         Copyright &copy; 2026 Guruz. All rights reserved.
         </div>
        </div>
        <div className="col-12 col-md-4 footer-address">
          <div className="d-flex flex-column justify-content-end footer-inner">
          <div className="d-flex mb-3 mb-md-0">
            <img width={24} height={24} src={Message} alt="" />
            <Link to='#' className="ms-2" onClick={(e) => {
                e.preventDefault();
                window.location.href = 'mailto:support@guruz.pro';
            }}>support@guruz.pro</Link>
          </div>

          <div className="d-flex mb-3 mb-md-0">
            <img width={24} height={24} src={Phone} alt="" />
            <div className="ms-2">+1 (925) 785-3078</div>
          </div>
          </div>
        </div>
      </div>
      
      </div>
    </div>
  );
}

export default Footer;
